export default "__VITE_ASSET__CXn3pa_l__"